<template>
  <div id="layLeft">
    <img class="img_1" src="@/assets/images/pulic_3.png" />
    <div class="top" v-if="!['/aqt','/External'].includes($route.path)">
      <i @click="getTo" class="iconshouye4 iconfont"></i>
      <p @click="getTo" class="aqt_lang_mn titlefont">
        {{ $t("m.home") | U2M }}
      </p>
    </div>
    <div class="logo">
      <img v-if="library_infor&&library_infor.library_id==28" src="@/assets/images/pulic_1.png" />
      <p v-else class="aqt_lang_mn titlefont">{{  (library_infor && library_infor.name_lang ? (library_infor.name_lang.mn || library_infor.name_lang.zh) : '') | U2M }}</p>
    </div>
    <div class="bottom">
      <Dropdown placement="right-end" @on-click="userClick">
        <img v-if="infoname.wx_img" :src="infoname.wx_img" />
        <p class="aqt_lang_mn">
          {{
            infoname
              ? infoname.nickname
                ? infoname.nickname
                : infoname.username
                ? infoname.username
                : infoname.tel
                ? infoname.tel
                : ""
              : "" | U2M
          }}
        </p>
        <DropdownMenu slot="list">
          <DropdownItem :name="2">{{ $t("m.logout") }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <!--      <i class="iconfont iconxiashuangjiantou"/>-->
    </div>
    <img class="img_2" src="@/assets/images/pulic_3.png" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      libType:''
    };
  },
  methods: {
    getTo() {
      this.$router.push({
        path:sessionStorage.getItem("gcm")=='school'?'External':"/aqt",
        query: {
          lib_type: sessionStorage.getItem("gcm"),
        },
      });
    },
    userClick() {
      let that = this;
      that.saveUserBehavior(0, "点击退出登录按钮", 0);
      let data = {
        login_id: JSON.parse(
          this.$crypto.get(localStorage.getItem("userInfos"))
        ).login_id,
      };

      that.$http.post("api/web/v1/member/signout", data).then((val) => {
        localStorage.clear();
        document.title = ''
        // sessionStorage.clear();
        that.$router.push({
          path: "/login",
          query: {
            lib_type: sessionStorage.getItem("gcm"),
          },
        });
      });
    },
    saveUserBehavior(type, mark, id) {
      let that = this;

      let info = {
        book_id: id,
        magazine_id: null,
        type: type,
        path: this.$route.path,
        mark: mark,
      };
      that.$store.dispatch("saveUserBehavior", info).then(() => {});
    },
  },
  computed: {
    infoname() {
      let vv = localStorage.getItem("userInfos")
        ? JSON.parse(this.$crypto.get(localStorage.getItem("userInfos")))
        : null;
      return vv;
    },
    library_infor: {
      get: function () {
        let myDate = localStorage.getItem("theme_color") ?
            JSON.parse(this.$crypto.get(localStorage.getItem("theme_color"))) : ''
        return myDate;
      },
      set: function (newValue) {
        return newValue;
      },
    }

  },
  created() {
    if(this.$route.path=='/External'){
      this.libType = 'school'
    }else if(this.$route.path=='/aqt'){
      this.libType = 'aqt'
    }else {
      this.libType = sessionStorage.getItem("gcm")
    }
  }
};
</script>
<style lang="less" scoped>
#layLeft {
  width: 80px;
  height: 100%;
  background: var(--themeColor);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .img_1 {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: auto;
  }

  .img_2 {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: auto;
  }

  .top {
    position: absolute;
    left: 0;
    top: 20px;
    width: 100%;
    min-height: 200px;
    color: #ffffff;
    font-size: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 999;

    i {
      font-size: 24px;
      cursor: pointer;
    }

    p {
      cursor: pointer;
    }
  }

  .logo {
    position: absolute;
    top:0px;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 18px;

    img {
      max-width: 100% !important;
      height: 33%;
      margin-top: 100px;
    }
    p{
      width: 100%;
      height: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      //padding-top: 100px;
    }
  }

  .bottom {
    position: absolute;
    left: 0;
    bottom: 35px;
    width: 100%;
    height: 250px;
    color: #ffffff;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;

    i {
      font-size: 14px;
      cursor: pointer;
    }

    p {
      cursor: pointer;
    }

    img {
      width: 35px;
      height: 35px;
      border-radius: 50%;
      margin-bottom: 5px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="less">
#layLeft {
  .ivu-dropdown-rel {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .ivu-select-dropdown {
    writing-mode: vertical-lr;
    text-orientation: sideways-right;
    text-orientation: sideways !important;
    -o-text-orientation: sideways !important;
    -ms-text-orientation: sideways !important;
    -moz-text-orientation: sideways !important;
    -webkit-text-orientation: sideways !important;
    -webkit-text-orientation: sideways-right !important;
    font-family: "MGQ8102" !important;
  }

  .ivu-dropdown-menu {
    min-width: 50px;
  }
}
</style>
